module.exports = __webpack_public_path__ + "img/h3xlogo.26dff422.svg";